import { render, staticRenderFns } from "./ColumnGroup.vue?vue&type=template&id=5145996d"
import script from "./ColumnGroup.vue?vue&type=script&lang=ts"
export * from "./ColumnGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports